import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { HiOutlineMail, HiOutlinePhone, HiOutlineUser, HiOutlineOfficeBuilding, HiOutlineBadgeCheck } from 'react-icons/hi';
import { FaUserCircle } from 'react-icons/fa';
import { InfinitySpin } from 'react-loader-spinner';
import axios from 'axios';
import { api_url } from '../../config';

const Profile = () => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const { id, branch_id, token } = useSelector(state => state.auth);

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                setLoading(true);
                const url = `${api_url}/api/v1/wholesaler/user/${id}/branch/${branch_id}/user-profile-single`;
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setUser(response.data.data);
            } catch (error) {
                console.error('Error fetching user details:', error);
            } finally {
                setLoading(false);
            }
        };

        if (id && branch_id && token) {
            fetchUserDetails();
        }
    }, [id, branch_id, token]);

    return (
        <div className='flex justify-center items-center min-h-[90vh] font-lufga py-8'>
            {loading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-xl z-50">
                        <InfinitySpin color="#059212" loading={loading} size={40} />
                    </div>
                )}
            <div className="w-full max-w-md rounded-xl shadow-xl bg-gradient-to-br border border-blue-800 from-blue-50 to-blue-100 p-6 relative">
                <div className="flex flex-col gap-6 items-center">
                    <div className="relative">
                        <div className="w-32 h-32 rounded-full shadow-lg bg-white flex items-center justify-center">
                            <FaUserCircle className="w-32 h-32 text-blue-600" />
                        </div>
                        <div className="absolute bottom-0 right-0 bg-blue-600 text-white p-1 rounded-full">
                            <HiOutlineBadgeCheck size={24} />
                        </div>
                    </div>

                    <div className="text-center">
                        <h5 className="text-2xl font-semibold text-gray-900 mb-1">
                            {`${user?.title || ''} ${user?.first_name} ${user?.last_name}`}
                        </h5>
                        <p className="text-blue-600 font-medium">{user?.position}</p>
                    </div>

                    <div className="w-full space-y-4">
                        <div className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <HiOutlineOfficeBuilding className="text-blue-600" size={20} />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Branch</p>
                                <p className="font-medium text-gray-900">{user?.branch?.name || 'Not assigned'}</p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <HiOutlineMail className="text-blue-600" size={20} />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Email</p>
                                <p className="font-medium text-gray-900">{user?.email}</p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <HiOutlinePhone className="text-blue-600" size={20} />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Phone</p>
                                <p className="font-medium text-gray-900">{user?.phone || 'Not provided'}</p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <HiOutlineUser className="text-blue-600" size={20} />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Username</p>
                                <p className="font-medium text-gray-900">{user?.username}</p>
                            </div>
                        </div>
                    </div>

                    <div className="w-full mt-4 text-center">
                        <p className="text-sm text-gray-500">
                            Member since {new Date(user?.created_at).toLocaleDateString()}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
